import {useMutation} from '@tanstack/react-query';
import axios from 'axios';
import {toast} from '@ui/toast/toast';
import {apiClient} from '../../http/query-client';

export interface ForgotPhoneNumberSendMobileOtpPayload {
  email: string;
  code: string;
  mobile_number: string;
}

export function useForgotPhoneNumberSendMobileOtp() {
  return useMutation({
    mutationFn: (payload: ForgotPhoneNumberSendMobileOtpPayload) =>
      sendMobileOtp(payload),
    onError: err => {
      const msg = axios.isAxiosError(err) && err.response?.data?.error;
      toast.danger(msg || 'There was an issue. Please try again.');
    },
  });
}

function sendMobileOtp(payload: ForgotPhoneNumberSendMobileOtpPayload) {
  return apiClient
    .post('forgot-phone-number/send-mobile-otp', payload)
    .then(response => response.data);
}
